import React from 'react';
import PublicLayout, { PublicHero, PUBLIC_CONTACT_EMAIL } from '../../components/layout/PublicLayout';
import { Mail, LifeBuoy, ShieldCheck } from 'lucide-react';

const Contact = () => (
  <PublicLayout title="Contact" description="Contact VSKR Legal for support, privacy questions, or account and data deletion requests.">
    <PublicHero eyebrow="Contact" title="Get in touch"
      subtitle="The fastest way to reach us is by email. Please include relevant details so we can help you quickly." />
    <section className="max-w-3xl mx-auto px-5 lg:px-8 pb-20">
      <div className="glass-card rounded-2xl p-8">
        <div className="flex items-center gap-3">
          <span className="w-12 h-12 rounded-xl flex items-center justify-center text-white" style={{ background: 'linear-gradient(135deg,#1E3A5F,#2D8CFF)' }}><Mail className="w-6 h-6" /></span>
          <div>
            <p className="text-sm opacity-60">Email us</p>
            <a href={`mailto:${PUBLIC_CONTACT_EMAIL}`} data-testid="contact-email" className="text-lg font-semibold text-[#2D8CFF] hover:underline">{PUBLIC_CONTACT_EMAIL}</a>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          <div className="p-4 rounded-xl bg-gray-500/5">
            <LifeBuoy className="w-5 h-5 text-[#2D8CFF] mb-2" />
            <p className="font-medium text-sm">Support</p>
            <p className="text-sm opacity-70">Help with accounts, access and LIOS.</p>
          </div>
          <div className="p-4 rounded-xl bg-gray-500/5">
            <ShieldCheck className="w-5 h-5 text-[#2D8CFF] mb-2" />
            <p className="font-medium text-sm">Privacy & Deletion</p>
            <p className="text-sm opacity-70">Privacy questions and deletion requests.</p>
          </div>
        </div>
        <p className="text-xs opacity-50 mt-6">We respond to messages sent to the address above. Additional contact details will be published here once finalised.</p>
      </div>
    </section>
  </PublicLayout>
);

export default Contact;
